import styled from 'styled-components'

export const Container = styled.section`
  float: left;
  width: 100%;
  background: url(${props => props.background}) center center no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;

  @media only screen and (max-width: 900px) {
    height: auto;
    background: none;
    flex-direction: column;
  }
`

export const ContainerImg = styled.img`
  display: none;

  @media only screen and (max-width: 900px) {
    display: block;
    max-width: 80%;
  }
`

export const BoxTexto = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1E2A3B;
  border-radius: 8px;
  padding: 0 50px;
  overflow: hidden;

  span {
    color: #fff;
    font-size: 18px;
    line-height: 26px;

    @media only screen and (max-width: 900px) {
      text-align: center;
    }

    strong {
      color: #00B9FF;
    }
  }

  @media only screen and (max-width: 900px) {
    flex-direction: column-reverse;
    padding: 30px;
    margin-top: 40px;
  }

`

export const BoxTextoSpan = styled.span`
  color: #fff;
  font-size: 18px;
  font-weight: bold;
`

export const BoxTextoImg = styled.img`
  margin: -10px 0 -10px 50px;

  @media only screen and (max-width: 900px) {
    margin: 0 0 30px 0;
  }
`
